import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { registerSW } from "./sw/register";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root no encontrado");

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerSW();
